var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDownBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron Down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.93306 7.47505C4.17714 7.23097 4.57286 7.23097 4.81694 7.47505L10 12.6581L15.1831 7.47505C15.4271 7.23097 15.8229 7.23097 16.0669 7.47505C16.311 7.71913 16.311 8.11486 16.0669 8.35893L10.4419 13.9839C10.1979 14.228 9.80214 14.228 9.55806 13.9839L3.93306 8.35893C3.68898 8.11486 3.68898 7.71913 3.93306 7.47505Z",
    fill: "#1D72E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownBlue);
export default __webpack_public_path__ + "static/media/chevron_down_blue.90a46dc9ec442c338987e315717f13b1.svg";
export { ForwardRef as ReactComponent };